import Vue from 'vue'
import moment from 'moment'
/**
 * 全局过滤器
 * 示例：格式化时间
  <p>{{ new Date() | formatTime('YYYY/MM/DD HH:mm') }}</p>
 */

const filters = {
  // 千位分割符 -- 过滤器
  formatMoney (value) {
    if (!value) {
      return '0'
    }
    // const intPartFormat = value.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') // 将整数部分逢三一断
    // return intPartFormat
    let result = ''
    if (typeof value === 'number') {
      result = value.toString().indexOf('.') !== -1
        ? value.toLocaleString()
        : value.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
    }
    if (typeof value === 'string') {
      result = value.indexOf('.') !== -1
        ? value.toLocaleString()
        : value.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
    }
    return result
  },
  // 格式化时间 过滤器
  formatTime (time, format = 'YYYY-MM-DD', language = 'zh') {
    if (!time) return ' -- '
    return moment(new Date(time)).format(format)
  }
}

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

// 格式化时间 过滤器
// Vue.filter('formatTime', function (time, format = 'YYYY-MM-DD', language = 'zh') {
//   if (!time) return ' -- '
//   return moment(new Date(time)).format(format)
// })
